document.addEventListener('DOMContentLoaded', function() {
  const guidanceItems = document.querySelectorAll('.guidance-item');
  
  guidanceItems.forEach(function(item) {
    const windowEl = item.querySelector('.guidance-item-window');
    const mask = item.querySelector('.guidance-window-mask');
    const closeBtn = item.querySelector('.guidance-window-btn');
    
    if (!windowEl) return;
    
    item.addEventListener('click', function(e) {
      if (e.target.closest('.guidance-item-window')) return;
      if (e.target.closest('.guidance-window-btn')) return;
      
      windowEl.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
    
    if (mask) {
      mask.addEventListener('click', function() {
        windowEl.classList.remove('active');
        document.body.style.overflow = '';
      });
    }
    
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        windowEl.classList.remove('active');
        document.body.style.overflow = '';
      });
    }
  });


  function onTidioChatApiReady() {
        window.tidioChatApi.hide();
    }

    if (window.tidioChatApi) {
        window.tidioChatApi.on("ready", onTidioChatApiReady);
    }

    document.querySelector(".chat-button").addEventListener("click", function () {
        window.tidioChatApi.show();
        window.tidioChatApi.open();
    });

});